import { Game } from '../game.model';
import { Player } from '../player.model';

export class Joined {
  game: Game;
  player: Player;
}
